<template>
  <section class="app-doc-tag-wrapper">
    <DocumentTagGroup
      v-for="(value, key) in data"
      :key="key"
      :data="value"
      :type="key"
      :name="fixTagsTransify(key)"
    ></DocumentTagGroup>
  </section>
</template>
<script lang="ts" setup>
import DocumentTagGroup from './TagGroup.vue'
import { DocumentTags } from '~/server/types'
defineProps({
  data: {
    type: Object as PropType<DocumentTags>,
    default: () => {}
  }
})
const { formatTransify } = useStore()
const fixTagsTransify = (key: string) => {
  key = key.toLowerCase()
  if (key.includes('addable')) {
    return formatTransify('UGC_OFFICIAL_WEBSITE_ADDABLE')
  }
  if (key.includes('combine')) {
    return formatTransify('UGC_OFFICIAL_WEBSITE_COMBINE')
  }
  if (key.includes('exclusive')) {
    return formatTransify('UGC_OFFICIAL_WEBSITE_EXCLUSIVE')
  }
  if (key.includes('rely')) {
    return formatTransify('UGC_OFFICIAL_WEBSITE_RELY')
  }
  if (key.includes('ownertypes')) {
    return formatTransify('UGC_OFFICIAL_WEBSITE_OWNER')
  }
  return ''
}
</script>
